import { cn } from '../cn';

/** Linear progress only (uploads, jobs). `value` undefined renders an indeterminate bar. */
export function Progress({ value, label, className }: { value?: number; label: string; className?: string }) {
  const indeterminate = value === undefined;
  return (
    <div
      role="progressbar"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={indeterminate ? undefined : Math.round(value)}
      className={cn('relative h-1 w-full overflow-hidden rounded-full bg-surface-muted', className)}
    >
      <div
        className={cn('h-full bg-accent', indeterminate && 'animate-progress w-2/5')}
        style={indeterminate ? undefined : { width: `${Math.min(100, Math.max(0, value))}%` }}
      />
    </div>
  );
}

/** 2px line under a table header or panel while data refreshes in the background. */
export function RefetchBar({ active, label }: { active: boolean; label: string }) {
  return (
    <div aria-hidden={!active} className="relative h-0.5 w-full overflow-hidden">
      {active ? <div role="status" aria-label={label} className="animate-progress absolute inset-y-0 w-2/5 bg-accent" /> : null}
    </div>
  );
}
